import { render, staticRenderFns } from "./DeclaracaoSimplificadaCadastro.vue?vue&type=template&id=4504c8f8&scoped=true&"
import script from "./DeclaracaoSimplificadaCadastro.vue?vue&type=script&lang=js&"
export * from "./DeclaracaoSimplificadaCadastro.vue?vue&type=script&lang=js&"
import style0 from "./DeclaracaoSimplificadaCadastro.vue?vue&type=style&index=0&id=4504c8f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4504c8f8",
  null
  
)

export default component.exports